import { useState, useEffect } from 'react';

export const getWindowDimensions = () => {
  // Prevents gatsby build error when building in node context
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return { innerWidth: 0, innerHeight: 0 };
  }

  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
};

export const useWindowDimensions = () => {
  // Prevents gatsby build error when building in node context
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser)
    return {
      innerWidth: 0,
      innerHeight: 0,
    };
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    function subscribe() {
      if (typeof window !== 'undefined') window.addEventListener('resize', handleResize);
    }

    function unsubscribe() {
      if (typeof window !== 'undefined') window.removeEventListener('resize', handleResize);
    }

    if (typeof window !== 'undefined') subscribe();

    return unsubscribe;
  }, []);

  return windowDimensions;
};
